import React from 'react';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import InformationIcon from 'mdi-react/InformationCircleOutlineIcon';

const InfoText = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.tertiary};
  max-width: 600px;
  margin-bottom: ${layout.measurements.spacing100};
  margin-top: ${layout.measurements.spacing050};

  a {
    color: ${p => p.theme.text.callToAction};

    &:hover {
      color: ${p => p.theme.text.callToActionHover};
    }
  }
`;

const Icon = styled(InformationIcon)`
  margin-right: ${layout.measurements.spacing025};
`;

type Props = {
  children: React.ReactNode;
};

const Info = ({ children }: Props) => {
  return (
    <InfoText>
      <Icon size={16} />
      {children}
    </InfoText>
  );
};

export default Info;
